<template lang="pug">
    div
      el-row
        el-col
          h3.title Summary
      el-row
        el-col
          el-form(:inline="true" label-position="top" size="mini")
            el-form-item(label="Rango de Fecha:")
              date-input(:inputModel="search" modelKey="dateRange" type="daterange")
            el-form-item(label="País:")
              select-input(:options="countries" :attribute="search" modelKey="country")
            el-form-item(label="Formato de Fecha:")
              select-input(:options="formatDate" :attribute="search" modelKey="formatDate")
            el-form-item(label="Columnas")
              select-input(
                class="columns-select"
                :style="columnsSelectStyle"
                :options="columnOptions"
                :attribute="columnsFilter"
                modelKey="selected"
                multiple
                placeholder="Selecciona columnas"
              )
            el-form-item.filters__buttons-wrapper
              el-button(
                type="primary"
                icon="el-icon-search"
                @click="fetchSummary()"
              ) FILTRAR
              el-button(
                type="success"
                icon="el-icon-download"
                @click.prevent="openExportDialog()"
              ) EXPORTAR
      el-row(:key="renderTable")
        el-col
          report-table(
            v-loading="loading"
            :headers="headers"
            :height="600"
            :paginated="true"
            :pageSize="100"
            :rowModel="'infinite'"
            :blockSize="100"
            :blocksInCache="100"
            :maxBlocksInCache="100"
            :datasourceRequests="1"
            @updateTable="updateTable"
          )
      el-dialog(
        title="Exportar Summary"
        :visible.sync="exportDialog.visible"
        :close-on-click-modal="false"
        width="70%"
        @close="closeExportDialog"
      )
        div.export-summary-dialog__content
          transfer-list(
            :data="exportDialog.data"
            :defaultColumns="exportDialog.defaultColumns"
            @handleExportList="updateExportColumns"
          )
        span(slot="footer")
          el-button(
            type="primary"
            @click="exportSummary()"
          ) Exportar Reporte
  </template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import DataTable from '@/components/tables/DataTable.vue';
import ReportTable from '@/components/tables/ReportTable.vue';
import DateInput from '@/components/forms/inputs/DateInput.vue';
import TransferList from '@/components/ui/TransferList.vue';

// eslint-disable-next-line import/no-cycle
import FinanceApi from '@/services/apiService';
import DataService from '@/services/dataService';
import DateService from '@/services/dateService';
import handleDownload from '@/utils/handleDownload';

export default {
  name: 'SummaryByDates',
  components: {
    SelectInput, DataTable, DateInput, ReportTable, TransferList,
  },
  data() {
    return {
      renderTable: 0,
      allHeaders: [
        { headerName: 'Fecha', field: 'date', filterType: 'text' },
        { headerName: 'Operador', field: 'bus_operator', filterType: 'text' },
        { headerName: 'Canal de venta', field: 'product_line', filterType: 'text' },
        { headerName: 'Tickets', field: 'tickets', filterType: 'text' },
        { headerName: 'GMV', field: 'gmv', filterType: 'text' },
        { headerName: 'Revenue', field: 'revenue', filterType: 'text' },
        { headerName: 'Transacciones', field: 'transactions', filterType: 'text' },
        { headerName: 'Comisión + IVA', field: 'commission_with_tax', filterType: 'text' },
        { headerName: 'Recorrido fee', field: 'recorrido_fee', filterType: 'text' },
        { headerName: 'Net offsets', field: 'net_offsets', filterType: 'text' },
      ],
      headers: [],
      columnOptions: [
        { key: 'date', value: 'Fecha' },
        { key: 'bus_operator', value: 'Operador' },
        { key: 'product_line', value: 'Canal de venta' },
        { key: 'tickets', value: 'Tickets' },
        { key: 'gmv', value: 'GMV' },
        { key: 'revenue', value: 'Revenue' },
        { key: 'transactions', value: 'Transacciones' },
        { key: 'commission_with_tax', value: 'Comisión + IVA' },
        { key: 'recorrido_fee', value: 'Recorrido fee' },
        { key: 'net_offsets', value: 'Net offsets' },
      ],
      columnsFilter: {
        selected: [
          'date',
          'bus_operator',
          'product_line',
          'tickets',
          'gmv',
          'revenue',
          'transactions',
          'commission_with_tax',
          'recorrido_fee',
          'net_offsets',
        ],
      },
      exportDialog: {
        visible: false,
        data: [
          { key: 'date', label: 'Fecha' },
          { key: 'bus_operator', label: 'Operador' },
          { key: 'product_line', label: 'Canal de venta' },
          { key: 'tickets', label: 'Tickets' },
          { key: 'gmv', label: 'GMV' },
          { key: 'revenue', label: 'Revenue' },
          { key: 'transactions', label: 'Transacciones' },
          { key: 'commission_with_tax', label: 'Comisión + IVA' },
          { key: 'recorrido_fee', label: 'Recorrido fee' },
          { key: 'net_offsets', label: 'Net offsets' },
        ],
        defaultColumns: [
          'date',
          'bus_operator',
          'product_line',
          'tickets',
          'gmv',
          'revenue',
          'transactions',
          'commission_with_tax',
          'recorrido_fee',
          'net_offsets',
        ],
        selectedColumns: [],
      },
      columns: [],
      search: {
        country: 'CL',
        date: '',
        dateRange: [
          DateService.addDate(-1, 'day', null),
          DateService.addDate(-1, 'day', null),
        ],
        formatDate: 'daily',
        filters: {},
      },
      loading: false,
      pagination: {},
      paramsApi: null,
      data: [],
      currentPage: 1,
      totalRows: 0,
      updateTable: async (params) => {
        this.paramsApi = params;
        const dataSource = {
          getRows: async (rowsParams) => {
            this.filterColumn(rowsParams.filterModel);
            this.paramsApi.api.showLoadingOverlay();
            this.data = await this.setSummary();
            const lastRow = this.totalRows;
            rowsParams.successCallback(this.data, lastRow);
            this.paramsApi.api.hideOverlay();
          },
        };
        this.paramsApi.api.setDatasource(dataSource);
      },
    };
  },
  created() {
    this.updateHeaders();
  },
  methods: {
    openExportDialog() {
      this.exportDialog.defaultColumns = [...this.exportDialog.defaultColumns];
      this.exportDialog.selectedColumns = [...this.exportDialog.defaultColumns];
      this.exportDialog.visible = true;
    },
    closeExportDialog() {
      this.exportDialog.visible = false;
    },
    updateExportColumns(columns) {
      this.exportDialog.selectedColumns = columns;
    },
    updateHeaders() {
      const selected = this.columnsFilter.selected || [];
      this.headers = this.allHeaders.filter((header) => selected.includes(header.field));
    },
    async setSummary() {
      if (this._.isEmpty(this.search.dateRange)) { this.search.dateRange = []; }

      const response = await FinanceApi.get_summary(this.currentPage, this.search, false);
      this.totalPages = response.body.total_pages;
      this.totalRows = response.body.total_records;
      this.currentPage += 1;
      this.loading = false;
      return response.body.records;
    },
    async fetchSummary() {
      this.updateHeaders();
      this.renderTable += 1;
      this.currentPage = 1;
      this.data = [];
    },
    exportSummary() {
      if (this.exportDialog.selectedColumns.length === 0) {
        this.$notify.error({ title: 'Error', message: 'Debe seleccionar al menos una columna' });
        return;
      }

      const exportSearch = {
        ...this.search,
        exportColumns: this.exportDialog.selectedColumns,
      };
      FinanceApi.get_summary(this.currentPage, exportSearch, true).then((res) => {
        handleDownload(res);
        this.closeExportDialog();
      });
    },
    filterColumn(filterModel) {
      const filterPresent = filterModel && Object.keys(filterModel).length > 0;
      if (filterPresent) {
        if (Object.keys(this.search.filters).length !== Object.keys(filterModel).length) {
          this.cleanSearchFilter('error');
        }
        Object.keys(filterModel).forEach((key) => {
          const filterValue = filterModel[key];
          if (this.search.filters[key] !== filterValue.filter) {
            this.search.filters[key] = filterValue.filter;
            this.cleanSearchFilter();
          }
        });
      } else if (Object.keys(this.search.filters).length > 0) {
        this.cleanSearchFilter('error');
      }
    },
    cleanSearchFilter(status) {
      if (status === 'error') { this.search.filters = {}; }

      this.currentPage = 1;
    },
  },
  computed: {
    countries() {
      return DataService.get_countries();
    },
    formatDate() {
      return DataService.FormatDate();
    },
    columnsSelectStyle() {
      const baseWidth = 180;
      const maxWidth = baseWidth * 2;
      const selectedCount = (this.columnsFilter.selected || []).length;
      if (selectedCount < 3 || selectedCount === 0) {
        return { width: `${baseWidth}px` };
      }
      const extraWidth = (selectedCount - 2) * 20;
      const width = Math.min(baseWidth + extraWidth, maxWidth);
      return { width: `${width}px` };
    },
  },
};
</script>

<style scoped>
.columns-select ::v-deep .el-select__tags .el-tag {
background-color: #c2e2fe;
border-color: hsl(203, 100%, 74%);
border: 1px solid #4fb6f6;
color: #1f2d3d;
}

.columns-select ::v-deep .el-select__tags .el-tag .el-tag__close {
background-color: #f4f5fb;
color: #0f4387;
}

.columns-select ::v-deep .el-select__tags .el-tag .el-tag__close:hover {
background-color: #246cca;
color: #ffffff;
}
</style>
